
// Загрузка пользователей Liferay
export const CurrentUserActions = {
    LOAD_STARTED: () => ({
        type: CurrentUserActions.LOAD_STARTED,
    }),
    LOAD_OK: currentUser => ({
        type: CurrentUserActions.LOAD_OK,
        currentUser,
    }),
    LOAD_ERROR: () => ({
        type: CurrentUserActions.LOAD_ERROR,
    }),
    LOAD_AUTH_STARTED: () => ({
        type: CurrentUserActions.LOAD_AUTH_STARTED,
    }),
    LOAD_AUTH_OK: value => ({
        type: CurrentUserActions.LOAD_AUTH_OK,
        value,
    }),
    LOAD_AUTH_ERROR: () => ({
        type: CurrentUserActions.LOAD_AUTH_ERROR,
    }),
};

export const ApplicationActions = {
    LOAD_STARTED: () => ({
        type: ApplicationActions.LOAD_STARTED,
    }),
    LOAD_OK: application => ({
        type: ApplicationActions.LOAD_OK,
        application,
    }),
    LOAD_ERROR: () => ({
        type: ApplicationActions.LOAD_ERROR,
    }),
};
